import { Image, Skeleton } from "antd";
import type { IEmployee } from "../../../../app/features/employee/employee.types";
import PassportIcon from "../../../../assets/icons/passport.svg";
import Section from "../_icons/Section";
import Info from "./Info";

type Props = {
  data?: IEmployee;
  loading?: boolean;
};

export default function PassportInfo({ data, loading }: Props) {
  const formatDate = (dateString?: string | null) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US");
  };

  return (
    <Section title="পাসপোর্ট তথ্য" type="passport">
      <div>
        {loading ? (
          <Skeleton.Node active style={{ width: 112, height: 128 }} />
        ) : (
          <Image
            width={112}
            height={128}
            className="object-cover rounded border border-theme-zinc-200"
            src={data?.passportFileUrl || PassportIcon}
            alt="Passport"
          />
        )}
      </div>
      <Info
        label="পাসপোর্ট নম্বর"
        value={
          loading ? (
            <Skeleton.Input active size="small" />
          ) : (
            data?.passportNumber || "N/A"
          )
        }
      />
      <Info
        label="মেয়াদ শেষ"
        value={
          loading ? (
            <Skeleton.Input active size="small" />
          ) : (
            formatDate(data?.passportExpireAt)
          )
        }
      />
    </Section>
  );
}
